module.exports = __webpack_public_path__ + "static/img/icon_float_ques.2597588e.png";